import { ActionContext, ActionTree } from 'vuex'

import { UpdateSpecialOfferDto } from '../../../api/@types'
import { SpecialOfferState, RootState } from '@/types/store'
import {
  getSpecialOffer,
  getSpecialOffers,
  updateSpecialOffer,
} from '@/api/special-offer'

type Context = ActionContext<SpecialOfferState, RootState>

export interface SpecialOfferActions
  extends ActionTree<SpecialOfferState, RootState> {
  updateSpecialOffer: (
    ctx: Context,
    payload: { id: string; body: UpdateSpecialOfferDto },
  ) => Promise<void>
}

export const actions: SpecialOfferActions = {
  async getSpecialOffers({ commit }, params): Promise<void> {
    commit('setIsSpecialOfferLoading', true)
    const specialOffers = await getSpecialOffers({ ...params } || null)
    commit('specialOfferLoaded', specialOffers)
    commit('setIsSpecialOfferLoading', false)
  },
  async getSpecialOffer({ commit }, id: string): Promise<void> {
    commit('setIsSpecialOfferLoading', true)
    const specialOffer = await getSpecialOffer(id)
    commit('setSpecialOffer', specialOffer)
    commit('setIsSpecialOfferLoading', false)
  },
  async updateSpecialOffer(
    { commit, dispatch },
    payload: { id: string; body: UpdateSpecialOfferDto },
  ): Promise<void> {
    commit('setIsSpecialOfferLoading', true)
    await updateSpecialOffer(payload.id, payload.body)
    await dispatch('getSpecialOffer', payload.id)
    commit('setIsSpecialOfferLoading', false)
  },
}
